import { render } from "./MarketsDashboard.vue?vue&type=template&id=1a11e036&scoped=true"
import script from "./MarketsDashboard.vue?vue&type=script&lang=js"
export * from "./MarketsDashboard.vue?vue&type=script&lang=js"

import "./MarketsDashboard.vue?vue&type=style&index=0&id=1a11e036&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a11e036"]])

export default __exports__